import { render, staticRenderFns } from "./modal-assign-partner.vue?vue&type=template&id=907e8cb0"
import script from "./modal-assign-partner.vue?vue&type=script&lang=js"
export * from "./modal-assign-partner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports